import MainCard, { MainCardProps } from '@/components/MainCard';
import { cn } from '@/components/ui';

const AuthCard = ({ children, className, ...other }: MainCardProps) => (
  <MainCard
    content={false}
    className={cn('m-5 max-w-auth-card border-0 shadow-auditor-overlay md:m-6 lg:max-w-auth-card-lg', className)}
    {...other}
  >
    <div className="p-4 sm:p-6 md:p-8 xl:p-10">{children}</div>
  </MainCard>
);

export default AuthCard;
